import AuthService from '../oauth/service'

import ConfigAuth from '../config/config'

class OAuth {
    constructor() {
        this.Session = localStorage
    }

    logout() {
        this.Session.removeItem('trekking_access_token')
        this.Session.removeItem('trekking_refresh_token')
        AuthService.destroySession()
    }

    guest() {
        return this.Session.getItem('trekking_access_token') == null
    }

    isAuthenticated() {
        return this.Session.getItem('trekking_access_token') != null
    }

    checkIfHasPermission(permissions) {

        // if (user) {
        //     let p = _.clone(user.permissions);
        //     p = p.map(r => {
        //         return r.name;
        //     });
        //     if (user.roles[0].name === "Super Admin") {
        //         return true;
        //     } else if (_.intersection(p, permissions).length > 0) {
        //         return true;
        //     } else {
        //         return false;
        //     }
        // } else {
        return true;
        // }

    }

    login(username, password, provider = 'trekkingagencyusers') {
        let data = {
            username,
            password,
            provider
        };
        // We merge grant type and client secret stored in configuration
        Object.assign(data, ConfigAuth.oauth);

        return new Promise((resolve, reject) => {
            AuthService.attemptLogin(data).then(response => {
                this.storeSession(response.data);
                this.addAuthHeaders();
                resolve(response)
            }).catch(error => {
                console.log('OAUTH Authentication error: ', error);
                reject(error)
            })
        })
    }

    reset(username) {
        let data = {
            username,
        }
        // We merge grant type and client secret stored in configuration
        Object.assign(data, ConfigAuth.oauth)

        return new Promise((resolve, reject) => {
            AuthService.attemptReset(data).then(response => {
                resolve(response)
            }).catch(error => {
                console.log('OAUTH reset error: ', error);
                reject(error)
            })
        })
    }

    getUser() {
        if (this.Session.getItem('trekking_access_token') != null) {
            return new Promise((resolve, reject) => {
                AuthService
                    .currentUser()
                    .then(response => {
                        resolve(response)
                    }).catch(error => {
                    reject(error)
                })
            })
        }
        return new Promise(resolve => resolve(null))
    }

    getAuthHeader() {
        if (this.Session.getItem('trekking_access_token') != null) {
            let accessToken = this.getItem('trekking_access_token');
            return ConfigAuth.oauth_type + ' ' + accessToken
        }
        return null
    }

    getItem(key) {
        return this.Session.getItem(key)
    }

    addAuthHeaders() {
        let header = this.getAuthHeader();
        AuthService.addAuthorizationHeader(header)
    }

    storeSession(data) {
        let t = new Date();
        t.setSeconds(t.getSeconds() + data.expires_in);
        this.Session.setItem('trekking_expires_in', t);
        this.Session.setItem('trekking_access_token', data.access_token);
        this.Session.setItem('trekking_refresh_token', data.refresh_token);
    }
}

export default OAuth
